import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { usePlaylist } from '../savedItemsQueries'; // @ts-expect-error Could not find a declaration file for module

import useFilterParams from '../../../hooks/useFilterParams';
import UsageTracker from '../../../utils/UsageTracker';
import { getPlaylistUrl } from '../../../utils/RoutingUtils';
import { useLocation } from 'react-router-dom';
import PlaylistThumbnailOverlayed from '../../../components/TrackCard/Thumbnail/PlaylistThumbnailOverlayed';
import ContentCard from '../../../components/TrackCard/ContentCard';

const PlaylistCard = ({
  playlistId,
  isFlushOnMobile = true,
  position,
  appearsIn,
  isGhost
}) => {
  const {
    playlist
  } = usePlaylist(playlistId);
  const filterParams = useFilterParams();
  const {
    search
  } = useLocation();
  const onClickHandler = useCallback(() => {
    if (!playlist) return;
    const {
      name
    } = playlist;
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'PLAYLIST',
      appearsIn,
      playlistId,
      position,
      name,
      filters: JSON.stringify(filterParams),
      style: 'default'
    });
  }, [appearsIn, filterParams, playlist, playlistId, position]);
  const to = useMemo(() => {
    if (!playlist) return null;
    const {
      id
    } = playlist;
    return {
      pathname: getPlaylistUrl(id),
      search // send language query params when isStarted = true?

    };
  }, [playlist, search]);
  if (!playlist) return null;
  const {
    name,
    description
  } = playlist;
  return /*#__PURE__*/_jsx(ContentCard, {
    "data-test-meta": playlistId,
    "data-test-type": "playlist",
    description: description,
    isFlushOnMobile: isFlushOnMobile,
    isGhost: isGhost,
    name: name,
    onClick: onClickHandler,
    thumbnailOverlayed: /*#__PURE__*/_jsx(PlaylistThumbnailOverlayed, {
      isGhost: isGhost,
      playlistId: playlistId
    }),
    to: to
  });
};

export default PlaylistCard;